export default __webpack_public_path__ + "locales/az/ChangePortalOwner.json?hash=63019590acc9078d307bf692e0497aa7";